import axios from "axios";
import { getCookie, setCookie, deleteCookie } from "../utils/cookie";
import { api } from "../api/api_route";

export const resetDataAndLogout = () => {
  ["accessToken", "refreshToken", "refreshExpiresIn", "accessExpiresIn"].forEach(deleteCookie);
  window.location.href = "/login";
};

export const setLoginCookies = (user) => {
  setCookie("accessToken", user.accessToken, user.refreshExpiresIn);
  setCookie("accessExpiresIn", user.accessExpiresIn, user.refreshExpiresIn);
  setCookie("refreshToken", user.refreshToken, user.refreshExpiresIn);
  setCookie("refreshExpiresIn", user.refreshExpiresIn, user.refreshExpiresIn);
};

export const getRefreshToken = async () => {
  try {
    const token = getCookie("refreshToken");
    const res = await axios.post(`${api}/users/refreshToken`, {}, {
      headers: { Authorization: `Bearer ${token}` }
    });

    if (res.data?.accessToken) {
      setLoginCookies(res.data);
      return res.data.accessToken;
    } else {
      resetDataAndLogout();
    }
  } catch (err) {
    resetDataAndLogout();
  }
};
